// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j_fS","footer":"styles_footer__3dGgn"};